import { useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { API, APIMethod } from '@brg/api';
import moment from 'moment';
import { ApiMethodCacheActions, ApiMethodCacheSelector } from 'shared/reducers/ApiMethodCacheSlice';

type ApiLoading = boolean;
type ApiError = string | undefined;

export type UseAPIMethodReturn<T> = [T[], ApiLoading, ApiError];

const createHash = (string: string) => {
    let hash = 0, i, chr;
    if (string.length === 0) return hash;
    for (i = 0; i < string.length; i++) {
        chr = string.charCodeAt(i);
        hash = ((hash << 5) - hash) + chr;
        hash |= 0; // Convert to 32bit integer
    }
    return hash;
}

const DEFAULT_CACHE_TIME = 1000 * 60 * 60;

const useCachedResponse = (args: any, cache?: boolean | number) => {
    const dispatch = useDispatch();
    const { table: responseTable } = useSelector(ApiMethodCacheSelector);

    // @ts-ignore
    const setResponse = useCallback((response) => {
      const hash = createHash(JSON.stringify(args));
      dispatch(ApiMethodCacheActions.setCachedResponse({ hash, response, args }));
    }, [args, dispatch]);

    const cachedValue = useMemo(() => {
        if (cache) {
            const cacheTime = typeof cache === 'number' ? cache : DEFAULT_CACHE_TIME;
            const hash = createHash(JSON.stringify(args));
            if (responseTable[hash] && moment().diff(responseTable[hash].time) < cacheTime) {
                return responseTable[hash].response;
            }
        }
    }, [args, cache, responseTable]);

    return [cachedValue, setResponse]
}

export const useAPIMethodArray = <T, K>(
    method: APIMethod<K, unknown>,
    args: K,
    lang = 'en',
    t?: number | string,
    disabled?: boolean,
    cache?: boolean | number,
): UseAPIMethodReturn<T> => {
    const [isLoading, setIsLoading] = useState<boolean>(!disabled);
    const [error, setError] = useState<string>();
    const [response, setResponse] = useState<T[]>([]);
    const [raw, setRaw] = useState<unknown>();
    const [cachedResponse, setCachedResponse] = useCachedResponse(args, cache);

    useEffect(() => {
        if (!disabled) {
            if (cachedResponse) {
                setRaw(cachedResponse);
                return;
            } else {
                setIsLoading(true);
            }
        }
        if (disabled) {
            return
        }
        method(args as any)
            .then((value) => value.json())
            .then((value) => {
                if (cache) {
                    setCachedResponse(value);
                }
                setRaw(value)
            })
            .catch((reason) => setError(reason));
    }, [t, disabled]);

    useEffect(() => {
        if (raw) {
            setError(undefined);
            setResponse(API.toLang(raw, lang) as T[]);
        }
    }, [raw, lang]);

    useEffect(() => {
        if ((response && raw) || error) {
            setIsLoading(false);
        }
    }, [response, raw, error]);

    return [response, isLoading, error];
};
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { API, APIMethod } from '@brg/api';
import moment from 'moment';
import { ApiMethodCacheActions, ApiMethodCacheSelector } from 'shared/reducers/ApiMethodCacheSlice';

type ApiLoading = boolean;
type ApiError = string | undefined;

export type UseAPIMethodReturn<T> = [T[], ApiLoading, ApiError];

const createHash = (string: string) => {
    let hash = 0, i, chr;
    if (string.length === 0) return hash;
    for (i = 0; i < string.length; i++) {
        chr = string.charCodeAt(i);
        hash = ((hash << 5) - hash) + chr;
        hash |= 0; // Convert to 32bit integer
    }
    return hash;
}

const DEFAULT_CACHE_TIME = 1000 * 60 * 60;

const useCachedResponse = (args: any, cache?: boolean | number) => {
    const dispatch = useDispatch();
    const { table: responseTable } = useSelector(ApiMethodCacheSelector);

    // @ts-ignore
    const setResponse = useCallback((response) => {
      const hash = createHash(JSON.stringify(args));
      dispatch(ApiMethodCacheActions.setCachedResponse({ hash, response, args }));
    }, [args, dispatch]);

    const cachedValue = useMemo(() => {
        if (cache) {
            const cacheTime = typeof cache === 'number' ? cache : DEFAULT_CACHE_TIME;
            const hash = createHash(JSON.stringify(args));
            if (responseTable[hash] && moment().diff(responseTable[hash].time) < cacheTime) {
                return responseTable[hash].response;
            }
        }
    }, [args, cache, responseTable]);

    return [cachedValue, setResponse]
}

export const useAPIMethodArray = <T, K>(
    method: APIMethod<K, unknown>,
    args: K,
    lang = 'en',
    t?: number | string,
    disabled?: boolean,
    cache?: boolean | number,
): UseAPIMethodReturn<T> => {
    const [isLoading, setIsLoading] = useState<boolean>(!disabled);
    const [error, setError] = useState<string>();
    const [response, setResponse] = useState<T[]>([]);
    const [raw, setRaw] = useState<unknown>();
    const [cachedResponse, setCachedResponse] = useCachedResponse(args, cache);

    useEffect(() => {
        if (!disabled) {
            if (cachedResponse) {
                setRaw(cachedResponse);
                return;
            } else {
                setIsLoading(true);
            }
        }
        if (disabled) {
            return
        }
        method(args as any)
            .then((value) => value.json())
            .then((value) => {
                if (cache) {
                    setCachedResponse(value);
                }
                setRaw(value)
            })
            .catch((reason) => setError(reason));
    }, [t, disabled]);

    useEffect(() => {
        if (raw) {
            setError(undefined);
            setResponse(API.toLang(raw, lang) as T[]);
        }
    }, [raw, lang]);

    useEffect(() => {
        if ((response && raw) || error) {
            setIsLoading(false);
        }
    }, [response, raw, error]);

    return [response, isLoading, error];
};
